/****************
 * WHICH FIRST VISIT A NEW ACCOUNT GETS: A SAMPLE OF EACH. 2026-10-22.
 *
 * Guillaume: "What is Mishka's chooser vs the Guided Get Started? Maybe we can
 * do a sample on both and compare."
 *
 *   chooser     Mishka's welcome by intent: what you came for, a video, a guide.
 *   getstarted  the Orb-guided Get Started: trader, strategy, backtest, practice.
 *
 * Half each, fixed per account (from its id, so web reloads and devices agree),
 * recorded once as first_visit_arm so the funnels can be split by it (PostHog
 * and the admin page: time to the first backtest and the first practice session,
 * who comes back).
 ****************/
export type FirstVisitArm = 'chooser' | 'getstarted';

export function firstVisitArm(userId: string): FirstVisitArm {
  let h = 0;
  for (let i = 0; i < userId.length; i++) h = (h * 31 + userId.charCodeAt(i)) | 0;
  return (h & 1) === 0 ? 'chooser' : 'getstarted';
}
